import { LOGIN_AZURE_AD_AUTHORIZED } from '.';
import {
  LoginState,
  LoginActionTypes,
  LOGIN_LOADING,
  LOGIN_PAGES_LOADING,
  LOGIN_IS_PUBLIC,
} from './Login.types';

const defaultState: LoginState = {
  user: null,
  loading: false,
  pagesLoading: false,
  azureAdAuthorized: false,
  isPublic: true,
};

export function loginReducer(
  state = defaultState,
  action: LoginActionTypes,
): LoginState {
  switch (action.type) {
    case LOGIN_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case LOGIN_PAGES_LOADING: {
      return {
        ...state,
        pagesLoading: action.payload,
      };
    }
    case LOGIN_AZURE_AD_AUTHORIZED: {
      return {
        ...state,
        azureAdAuthorized: action.payload,
      };
    }
    case LOGIN_IS_PUBLIC: {
      return {
        ...state,
        isPublic: action.payload,
      };
    }
    default:
      return state;
  }
}
